import React from 'react';
import { useSmartProp, useEditor } from '@smartfire/js-block-engine';
import * as BlockEditor from '@wordpress/block-editor';
const RichText = BlockEditor === null || BlockEditor === void 0 ? void 0 : BlockEditor.RichText;
export default function EditableText(_ref) {
  let {
    smartProp,
    className = undefined,
    style = undefined,
    tagName = 'div',
    tagProps = {},
    render = function (value) {
      let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let TagName = arguments.length > 2 ? arguments[2] : undefined;
      return React.createElement(TagName, {
        dangerouslySetInnerHTML: {
          __html: value
        },
        ...props
      });
    },
    ...props
  } = _ref;
  const [value, updateValue] = useSmartProp(smartProp);
  const {
    isEditing
  } = useEditor();

  if (isEditing) {
    return React.createElement(RichText, {
      tagName: tagName,
      placeholder: '...',
      allowedFormats: [],
      value: value,
      className: className + ' editableInput',
      onChange: updateValue,
      ...props
    });
  } else {
    return render(value, {
      className,
      style,
      ...tagProps
    }, tagName);
  }
}